<template>
  <van-popup v-model="showBind" position="bottom" class="backRect" @closed="onClosed">
    <div class="inputRect">
      <div class="title">选择电子保单</div>
      <div class="dataRect">
        <div v-if="!list || list.length<=0" class="emptyRemark">暂未找到匹配保单，请检查被保险人姓名和证件号码是否一致!</div>
        <div
          v-for="(item,index) in list"
          :key="index"
          :style="index===selectId?'border-color:'+GetColorMainBack():''"
          :class="index===selectId?'dataLine dataLineSelect':'dataLine'"
          @click="onSelect(index)"
        >
          <div class="insuranceOrderInfo">
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">保险:<span>  {{ item.order.productName }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24">
                <div class="lineValue breakAll">保障期限:<span> {{ item.orderInfo.deadlineText }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <div class="lineValue breakAll">保单号:<span> {{ item.order.insureNum }}</span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">保障日期:<span> {{ item.orderInfo.deadline }}</span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <div class="lineValue breakAll">生效状态:<span>  <van-tag plain :color="GetColorMainBack()">{{ GetEnumText('Em_EffectiveStatus',item.order.effectiveStatus) }}</van-tag></span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">出单状态:<span>  <van-tag plain :color="GetColorMainBack()"> {{ GetEnumText('Em_IssueStatus',item.order.issueStatus) }}</van-tag></span></div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">
                <div class="lineValue breakAll">支付状态:<span>  <van-tag plain :color="GetColorMainBack()">{{ GetEnumText('Em_InsurancePayStatus',item.order.payStatus) }}</van-tag></span></div>
              </van-col>
              <van-col span="12">
                <div class="lineValue breakAll">支付时间:<span> {{ item.order.payTime?formatDate(item.order.payTime,'yyyy/MM/dd',true):'-' }}</span></div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <div class="buttonRect">
        <van-button type="primary" :disabled="!selectId" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onChangeInsuranceOrder">保存</van-button>
      </div>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Tag } from 'vant'
import { formatDate, GetEnumText, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tag.name]: Tag
  },
  props: {
    // eslint-disable-next-line
    value:undefined
  },
  data() {
    return {
      title: '选择电子保单',
      showBind: false,
      buttonLoading: false,
      studentId: undefined,
      list: [],
      selectId: undefined
    }
  },
  watch: {
    value(newValue) {
      this.list = []
      this.selectId = undefined
      if (newValue) {
        this.showBind = true
        this.studentId = newValue
        this.init()
      } else {
        this.showBind = false
        this.studentId = undefined
      }
    }
  },
  created() {

  },
  methods: {
    formatDate,
    GetEnumText,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      request({
        url: '/divetrip/getDiveTripInsurance',
        method: 'post',
        data: {
          studentId: this.studentId,
          isGetList: true
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
        this.list.forEach(item => {
          item.orderInfo = JSON.parse(item.order.body)
        })
      })
    },
    onSelect(index) {
      this.selectId = index
      console.log('index', index)
      this.list = JSON.parse(JSON.stringify(this.list))
    },
    onClosed() {
      this.$emit('input', false)
    },
    onChangeInsuranceOrder(id) {
      if (this.selectId === undefined) {
        MyNotify('info', '请选择一个电子保单')
        return
      }
      this.buttonLoading = true
      request({
        url: '/divetrip/setDiveTripInsurance',
        method: 'post',
        data: {
          studentId: this.studentId,
          insuranceOrderId: this.list[this.selectId].order.insuranceOrderId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '切换保单成功!')
        this.$emit('reload')
        this.showBind = false
      })
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    background-color: #fff;
}
.backRect .title{
    text-align: center;
    padding: 1em;
}
.backRect .imageUploadRect{
    padding: 1em;
}
.dataRect{
    padding: 1em;
    max-height: 60vh;
    overflow-y: scroll;
}
.dataLine{
    border: 1px solid #f5f5f5;
    padding:0.25em;
    margin:0.5em 0;
}
.lineValue{
    font-size: 0.9em;
    margin-bottom: 0.25em;
     color: #999;
}
.lineValue span{
   color: #000;
   margin-left: 0.5em;
}
.emptyRemark{
    text-align: center;
    font-size: 0.8em;
    color: #999;
    padding: 5em 1em;
}
</style>
